import { useEffect, useState, useCallback } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { PopularTopicsBox } from "./components/PopularTopicsBox";
import { AskedQuestions } from "./components/AskedQuestions";
import { SelfhelpVideos } from "./components/SelfhelpVideos";
import rightArrow from "../../../assets/VZY/clarity_arrow-line.svg";
import languageArrow from "../../../assets/VZY/language-arrow.png";
import { BrowserView, MobileView } from "react-device-detect";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay } from "swiper/modules";
import "swiper/css";
import { useSearchParams } from "react-router-dom";

export const HelpSupport = () => {
  const apiBaseURL = process.env.REACT_APP_API_URL || window.location.origin;
  const navigate = useNavigate();
  const [videoList, setVideoList] = useState([]);
  const [popularTopic, setPopularTopic] = useState([]);
  const [faqListData, setFaqListData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const REDIRECT_URL = "https://vzy.one/en/account";
  const [searchParams] = useSearchParams();
  useEffect(() => {
    const urlToken = searchParams.get("a_t");
    const urlSid = searchParams.get("sid");
    const urlMno = searchParams.get("mno");

    const storedData = JSON.parse(
      sessionStorage.getItem("helpSupportData") || "{}",
    );
    if (urlToken) {
      const data = {
        token: urlToken,
        sid: urlSid || "",
        mno: urlMno || "",
      };

      sessionStorage.setItem("helpSupportData", JSON.stringify(data));
      return;
    }
    if (!storedData.token) {
      window.location.replace(REDIRECT_URL);
    }
  }, [searchParams]);

  const fetchSelfHelpVideoList = useCallback(async () => {
    setLoading(true);
    setError("");
    try {
      const payload = {
        contentCode: "",
        contentTypeID: 2,
        categoryID: 0,
        isActive: 1,
        pageNumber: 1,
        pageSize: 8,
        searchValue: "",
        CategoryIDs: [],
      };
      const response = await axios.post(
        `${apiBaseURL}/api/VZYHelpSupport/FetchRelatedVideo`,
        payload,
        {
          headers: { "Content-Type": "application/json" },
        },
      );
      setVideoList(response?.data?.result?.relatedVideos ?? []);
    } catch (err) {
      console.error("FetchSelfHelpVideoList error:", err);
      setError("Failed to load videos. Please try again.");
    } finally {
      setLoading(false);
    }
  }, []);
  const FetchPopularTopicList = useCallback(async () => {
    setLoading(true);
    setError("");
    try {
      const payload = {
        contentTypeID: 3,
        categoryID: 0,
        isActive: 0,
        pageNumber: 1,
        pageSize: 6,
      };
      const response = await axios.post(
        `${apiBaseURL}/api/VZYHelpSupport/FetchPopularTopicCategory`,
        payload,
        {
          headers: { "Content-Type": "application/json" },
        },
      );
      setPopularTopic(response?.data?.result?.popularTopicsList ?? []);
    } catch (err) {
      console.error("FetchSelfHelpVideoList error:", err);
      setError("Failed to load videos. Please try again.");
    } finally {
      setLoading(false);
    }
  }, []);

  const FetchFAQList = useCallback(async () => {
    setLoading(true);
    setError("");
    try {
      const payload = {
        contentCode: "",
        contentTypeID: 1,
        categoryID: 0,
        isActive: 1,
        pageNumber: 1,
        pageSize: 6,
        searchValue: "",
        CategoryIDs: [],
      };

      const response = await axios.post(
        `${apiBaseURL}/api/VZYHelpSupport/FetchFAQ`,
        payload,
        {
          headers: { "Content-Type": "application/json" },
        },
      );

      setFaqListData(response?.data?.result?.fAQs ?? []);
    } catch (err) {
      console.error("FetchSelfHelpVideoList error:", err);
      setError("Failed to load videos. Please try again.");
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchSelfHelpVideoList();
    FetchPopularTopicList();
    FetchFAQList();
  }, [fetchSelfHelpVideoList, FetchPopularTopicList, FetchFAQList, apiBaseURL]);

  const renderVideos = () => {
    if (loading) {
      return <p className="loaderVZY-data">Loading...</p>;
    }

    if (!loading && !error && videoList.length === 0) {
      return <p className="not-found-title">No videos found.</p>;
    }

    if (videoList.length > 0) {
      return videoList.map((video, index) => (
        // <div key={index} className="video-item">
        //   <SelfhelpVideos fetchHelpVideoList={[video]} />
        // </div>
        <SelfhelpVideos fetchHelpVideoList={[video]} />
      ));
    }

    return null;
  };

  return (
    <>
      <BrowserView>
        <section className="vzy-common-box">
          <div className="container">
            <h1 className="title-Heading">
              Self-help videos, tips, tricks & more
            </h1>

            <div className="video-row">{renderVideos()}</div>

            {videoList.length > 0 && (
              <button
                type="button"
                className="view-all-video-btn"
                onClick={() => navigate("/VZYSupport/VideoList")}
              >
                View All Tutorials &nbsp;
                <img src={rightArrow} alt="View all videos" />
              </button>
            )}
          </div>
        </section>
      </BrowserView>

      <MobileView>
        <section className="vzy-common-box">
          <div className="container">
            <h1 className="title-Heading">
              Self-help videos, tips, tricks & more
            </h1>

            {loading && <p className="loaderVZY-data">Loading...</p>}
            {!loading && !error && videoList.length === 0 && (
              <p className="not-found-title">No videos found.</p>
            )}

            {videoList.length > 0 && (
              <Swiper
                modules={[Autoplay]}
                // loop
                autoplay={{
                  delay: 2500,
                  disableOnInteraction: false,
                  pauseOnMouseEnter: true,
                }}
                centeredSlides
                centeredSlidesBounds
                breakpoints={{
                  0: { slidesPerView: 1.4, spaceBetween: 12 },
                  480: { slidesPerView: 2.2, spaceBetween: 12 },
                  768: { slidesPerView: 2.4, spaceBetween: 20 },
                }}
                className="mySwiper video-row-mobile"
              >
                {videoList.map((video, index) => (
                  <SwiperSlide key={video?.contentID ?? index}>
                    <SelfhelpVideos fetchHelpVideoList={[video]} />
                  </SwiperSlide>
                ))}
              </Swiper>
            )}

            {videoList.length > 0 && (
              <button
                type="button"
                className="view-all-video-btn"
                onClick={() => navigate("/VZYSupport/VideoList")}
              >
                View All Tutorials &nbsp;
                <img src={rightArrow} alt="View all videos" />
              </button>
            )}
          </div>
        </section>
      </MobileView>

      <section className="vzy-common-box">
        <div className="container">
          <h1 className="title-Heading">Browse Popular Topics</h1>
          <div className="popular-topics-row">
            <PopularTopicsBox popularTopic={popularTopic} />
          </div>
        </div>
      </section>

      <section className="vzy-common-box">
        <div className="container">
          <h1 className="title-Heading">Frequently Asked Questions</h1>
          <p className="title-slag-heading">
            Find quick answers to common questions
          </p>

          <div className="faq-accordian">
            <AskedQuestions faqListData={faqListData} />

            <button
              type="button"
              className="view-all-video-btn"
              onClick={() => navigate("/VZYSupport/FaqList")}
            >
              View All FAQs &nbsp;
              <img src={rightArrow} alt="View all FAQs" />
            </button>
          </div>
        </div>
      </section>
    </>
  );
};
